import { render } from "./KpiSelectionModal.vue?vue&type=template&id=3b517e04&scoped=true"
import script from "./KpiSelectionModal.vue?vue&type=script&lang=js"
export * from "./KpiSelectionModal.vue?vue&type=script&lang=js"

import "./KpiSelectionModal.vue?vue&type=style&index=0&id=3b517e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b517e04"]])

export default __exports__